<section class="seller-container">
  <form [formGroup]="formStepOne" autocomplete="off">
    <section class="ids-pt-8">
      <h2 class="ids-text-title-01">dados da empresa</h2>

      <section class="ids-row ids-pt-8">
        <ids-form-field
          class="ids-col-6"
          label="Razão social"
          [errorMessage]="getTextFieldError('corporateName', 'a razão social')"
        >
          <input idsInput formControlName="corporateName"/>
        </ids-form-field>

        <ids-form-field class="ids-col-6" label="CNPJ" [errorMessage]="getErrorInvalid('CNPJ')">
          <input
            idsInput
            [idsMask]="maskCpfCnpj"
            formControlName="documentNumber"
          />
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="tipo de sociedade"
          [errorMessage]="getForgotFill('o órgão expedidor')"
        >
          <ids-select class="ids-mt-2" formControlName="companyType" required>
            <ids-option
              *ngFor="let option of sociedade"
              [value]="option.optValue"
            >
              {{ option.optLabel }}
            </ids-option>
          </ids-select>
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="data da última alteração social ou estatuária"
          [errorMessage]="getDateFieldError('lastChangeDate', 'a data da última alteração social ou estatuária')"
        >
          <input
            idsDatepicker
            formControlName="lastChangeDate"
          />
        </ids-form-field>
      </section>
    </section>

    <section class="ids-pt-8">
      <h3 class="ids-text-section-02 ids-pv-4">contato</h3>
      <section class="ids-row">
        <ids-form-field class="ids-col-6" label="E-mail" [errorMessage]="getEmailFieldError('contact_email', 'o e-mail')">
          <input type="email" (blur)="normalizeEmail('contact_email')"  idsInput formControlName="contact_email"/>
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="Celular ou telefone"
          [errorMessage]="getTextFieldError('contact_phone','o celular ou telefone')"
        >
          <input
            idsInput
            [idsMask]="phoneMask"
            formControlName="contact_phone"
            type="numeric"
            required
            errorMessage="o preenchimento do celular é obrigatório"
          />
        </ids-form-field>
      </section>
    </section>

    <section class="ids-pt-8">
      <app-cep-search
        [formParent]="formStepOne"
        [formControlNames]="[
          'address_zipCode',
          'address_state',
          'address_city',
          'address_district',
          'address_street',
          'address_number',
          'address_complement'
        ]"
        title="endereço comercial"
        ngDefaultControl
        (formParentChange)="formStepOne = $event"
      >
      </app-cep-search>
    </section>
  </form>
</section>
